export const dcm = {
  state: {
    dcmProfiles: [],
    dcmProfileAsked: false,
    dcmProfileId: null,
    dcmPublishSettings: false,
    dcmAdvertisers: [],
    dcmAdvertiserId: null,
    dcmCampaigns: [],
    dcmCampaignId: null,
    dcmPublishType: null,
    dcmPoliteLoad: false,
    dcmName: '{{campaign_name}} {{size_format}}'
  },
  reducers: {
    setDcmProfiles(state, action) {
      state.dcmProfiles = action.payload;
    },
    setProfileAsked(state, action) {
      state.dcmProfileAsked = action.payload;
    },
    setDcmProfileId(state, action) {
      state.dcmProfileId = action.payload;
    },
    setDcmPublishSettings(state, action) {
      state.dcmPublishSettings = action.payload;
    }, 
    setDcmAdvertisers(state, action) {
      state.dcmAdvertisers = action.payload;
    },
    setDcmAdvertiserId(state, action) {
      state.dcmAdvertiserId = action.payload;
    },
    setDcmCampaigns(state, action) {
      state.dcmCampaigns = action.payload;
    },
    setDcmCampaignId(state, action) {
      state.dcmCampaignId = action.payload;
    },
    setDcmPublishType(state, action) {
      state.dcmPublishType = action.payload;
    },
    setDcmPoliteLoad(state, action) {
      state.dcmPoliteLoad = action.payload;
    },
    setDcmName(state, action) {
      state.dcmName = action.payload;
    },
    resetDcmState(state) {
      state.dcmProfileAsked= false;
      state.dcmProfileId= null;
      state.dcmPublishSettings= false;
      state.dcmAdvertisers= [];
      state.dcmAdvertiserId= null;
      state.dcmCampaigns= [];
      state.dcmCampaignId= null;
      state.dcmPublishType= null;
      state.dcmPoliteLoad = false;
      state.dcmName = '{{campaign_name}} {{size_format}}';
    }
  },
  getExtraReducers(builder) {
    return null;
  }
}